import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const NavigationalHomeIcon: FunctionComponent<IconProps> = ({
  fill = 'none',
  width = 22,
  height = 25,
  customColour,
  ...rest
}) => {
  const strokeColour = customColour ? customColour : '#0050B3'

  return (
    <Icon
      data-testid="icon-navigationalHome"
      fill={fill}
      fillRule="evenodd"
      height={height}
      className={styles.interactiveStrokeColor}
      stroke={strokeColour}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <path d="M17.5 11v9h-4v-2.455c0-1.307-.252-4.069-3-4.069s-3 2.584-2.995 3.925l-.005.144V20h-4v-9" />
      <path d="M.926 13.517 10.558 3.35l9.631 10.167" />
    </Icon>
  )
}
